import axios from 'axios'
import { explorerApi } from '../client'
import type { GeneralSecretRequest } from '../repository'


interface SecretKeyResponse {
  SECRET: string // Base64 인코딩된 인덱스 값
  DATALIST: string[] // 36개의 랜덤 hex 배열
}

export const requestSecretKeyApi = async (request: GeneralSecretRequest): Promise<SecretKeyResponse> => {
  try {
    const data = await explorerApi.secretController.getSecretKey({
      requestBody: {
        hash: request.hash
      }
    })
    
    return data
  } catch (error) {
    console.error('🔑 [requestSecretKeyApi] API 요청 실패:', error)
    throw error
  }
}
